import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

console.log("[MSAL] msalInstance.js loaded");
// Only ever create ONE instance of PublicClientApplication
export const msalInstance = new PublicClientApplication(msalConfig);
console.log("[MSAL] msalInstance created", msalInstance);
